"use client";
import React from "react";
import Image from "next/image";
import dynamic from "next/dynamic";
import Link from "next/link";
const CommonBtn = dynamic(() => import("@/components/buttons/CommonBtn"), {
  ssr: false,
  loading: () => (
    <a href="/" className="btn btn-primary">
      Loading...
    </a>
  ),
});
// const ComanButton = dynamic(() => import("@/components/coman-button"), {
//   ssr: false,
//   loading: () => (
//     <a href="/" className="btn btn-primary">
//       Loading...
//     </a>
//   ),
// });

export default function Error() {
  return (
    <>
      <section className="section-py">
        <div className="container-xs px-3">
          <div className="text-center">
            <div>
              <Image
                src="/assets/images/not-found/Not-Found.webp"
                alt="Blank-Wishlist-Image"
                width={928}
                height={672}
                loading="lazy"
                className="img-fluid"
              />
            </div>
            <div className="mt-4 pt-2">
              {/* <ComanButton title="Shop Now" href="/" /> */}
              <CommonBtn
                variant="hover-outline"
                as={Link}
                href="/"
                className="position-relative px-3"
              >
                <span
                  className={`fs-5 fw-normal text-capitalize z-1 text-nowrap`}
                >
                  Shop Now
                </span>
              </CommonBtn>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
